import { View, Text } from "react-native";
import React from "react";
import Svg, { Path } from "react-native-svg"; // Import the necessary components

const FowardFlatArrow = ({ color, rotate = "0deg" }) => {
  return (
    <View style={{ transform: [{ rotate }] }}>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <Path d="M9 6L15 12L9 18" stroke={color} />
      </Svg>
    </View>
  );
};

export default FowardFlatArrow;
